import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CategoryContext } from "../../components/CategoryContext";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Switcher from "../../components/switcher";
import Tagline from "../../components/tagline";
import ScrollToTop from "../../components/scroll-to-top";
import BottomNav from "../../components/bottomnav.jsx";
import { getProductsByCategory } from "../../ApiService/productcategory/productcategory";
import heroBg from "../../assets/images/hero/front-banner.jpg";
import ctaImg from "../../assets/images/hero/bg-shape.png";
import {
  FiHeart,
  FiEye,
  FiBookmark,
  FiFilter,
  FiEdit,
} from "../../assets/icons/vander";
import { collections, newProduct } from "../../data/data";
import { getCurrencySymbol } from "../../ApiService/stockapi/currency.js";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { getProductsdetail } from "../../ApiService/productdetail/productdetail";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { fetchtrendingproducts } from "../../ApiService/Trendingproducts/trendingproducts";
import { fetchbannerapi } from "../../ApiService/homebannerapi/homebannerapi";
import { getProductsBybrand } from "../../ApiService/Brand/productbrand";
import { CartContext } from "../../components/CartContext";
import { getProductsBysubCategory } from "../../ApiService/productsubcatagory/productsubcategory";
import { addTowishlistApi } from "../../ApiService/addtowishlist/addtowishlist";
import toast from "react-hot-toast";
const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;

export default function Index() {
  let [days, setDays] = useState(0);
  let [hours, setHours] = useState(0);
  let [minutes, setMinutes] = useState(0);
  let [seconds, setSeconds] = useState(0);
  let [catproducts, setCatProducts] = useState([]);
  let [products, setProducts] = useState([]);
  const [banners, setBanners] = useState([]);
  const [bannerLoading, setBannerLoading] = useState(true);
  let deadline = "December, 31, 2024";
  const { addToCart } = useContext(CartContext);

  const { Product, categories, brand, loading, error } =
    useContext(CategoryContext);
  const navigate = useNavigate();

  const [trendingProducts, setTrendingProducts] = useState([]);
  const [trendingLoading, setTrendingLoading] = useState(true);
  const [trendingError, setTrendingError] = useState(null);

  useEffect(() => {
    const loadTrending = async () => {
      try {
        setTrendingLoading(true);
        setTrendingError(null);
        const data = await fetchtrendingproducts();
        setTrendingProducts(Array.isArray(data.results) ? data.results : []);
      } catch (err) {
        console.error("Failed to fetch trending products:", err);
        setTrendingError(err.message || "");
        setTrendingProducts([]);
      } finally {
        setTrendingLoading(false);
      }
    };

    loadTrending();
  }, []);

  useEffect(() => {
    const loadBanners = async () => {
      try {
        setBannerLoading(true);
        const data = await fetchbannerapi();

        const activeBanners = data
          .filter(
            (banner) =>
              banner.banner_status === true &&
              banner.banner_images &&
              banner.banner_images.length > 0
          )
          .map((banner) => ({
            id: banner.banner_id,
            title: banner.banner_heading,
            description: banner.banner_description,
            image: banner.banner_images[0].image,
            button_text: banner.button_text || "Shop Now",
            brand_id: banner.brand_name_id,
            category_id: banner.category_name_id,
            sub_category_id: banner.subCategory_name_id,
            raw_data: banner,
          }));

        setBanners(activeBanners);
      } catch (err) {
        console.error("Failed to fetch banners:", err);
        setBanners([]);
      } finally {
        setBannerLoading(false);
      }
    };

    loadBanners();
  }, []);

  const handleBannerClick = async (banner) => {
    try {
      const { brand_id, category_id, sub_category_id } = banner;

      if (brand_id) {
        const data = await getProductsBybrand(brand_id);
        setbrandproduct(data);
        navigate(`/shop-grid-left-sidebar/brand/${brand_id}`);
      } else if (category_id) {
        const data = await getProductsByCategory(category_id);
        setCatProducts(data);
        navigate(`/shop-grid-left-sidebar/category/${category_id}`);
      } else if (sub_category_id) {
        const data = await getProductsBysubCategory(sub_category_id);
        setsubcatagories(data);
        navigate(`/shop-grid-left-sidebar/subcategory/${sub_category_id}`);
      } else {
        navigate("/shop-grid-left-sidebar");
      }
    } catch (err) {
      console.error("Banner navigation error:", err);
      navigate("/shop-grid-left-sidebar");
    }
  };

  const [subcatagories, setsubcatagories] = useState([]);

  const handleCategoryClick = async (categoryId) => {
    try {
      const data = await getProductsByCategory(categoryId);
      setCatProducts(data);
      navigate(`/shop-grid-left-sidebar/category/${categoryId}`);
    } catch (err) {
      console.error("Failed to fetch products for category:", err);
    }
  };

  const [brandproduct, setbrandproduct] = useState([]);
  const handlepbrandClick = async (brandId) => {
    try {
      const data = await getProductsBybrand(brandId);
      setbrandproduct(data);
      navigate(`/shop-grid-left-sidebar/brand/${brandId}`);
    } catch (err) {
      console.error(err);
    }
  };

  const handleProductClick = async (productId) => {
    try {
      const data = await getProductsdetail(productId);
      setProducts(data);
      navigate(`/product-detail-three/products/${productId}`);
    } catch (err) {
      console.error("Failed to fetch products detail:", err);
    }
  };

  const handleCustomizeClick = (product) => {
    navigate(`/customize/${product.product_id}`, { state: { product } });
  };

  let getTime = () => {
    let time = Date.parse(deadline) - Date.now();
    setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
    setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
    setMinutes(Math.floor((time / 1000 / 60) % 60));
    setSeconds(Math.floor((time / 1000) % 60));
  };

  useEffect(() => {
    let interval = setInterval(() => getTime(deadline), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Navbar
        navClass="defaultscroll is-sticky tagline-height"
        navlight={true}
      />

      {/* Responsive Banner Section */}
      <section className="relative w-full bg-emerald-500/5 bg-center bg-no-repeat bg-cover">
        {bannerLoading ? (
          <div className="container text-center py-20">
            <p className="text-slate-400 animate-pulse">Loading banners...</p>
          </div>
        ) : banners.length > 0 ? (
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            spaceBetween={0}
            slidesPerView={1}
            className="w-full h-[50vh] md:h-[70vh] lg:h-screen"
          >
            {banners.map((banner, index) => (
              <SwiperSlide key={banner.id || index}>
                <div
                  className="relative w-full h-[50vh] md:h-[70vh] lg:h-screen bg-cover bg-center flex items-center justify-center"
                  style={{
                    backgroundImage: `url(${BASE_MEDIA_URL}${banner?.image})`,
                  }}
                >
                  <div className="absolute inset-0 bg-black/50"></div>
                  <div className="relative z-10 text-white text-center px-4 md:px-0 max-w-3xl mx-auto">
                    <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
                      {banner.title || "Discover New Arrivals"}
                    </h3>
                    {banner.description && (
                      <p className="text-base sm:text-lg md:text-xl max-w-2xl mx-auto mb-6 md:mb-8">
                        {banner.description}
                      </p>
                    )}
                    <button
                      onClick={() => handleBannerClick(banner)}
                      className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-2 px-4 sm:py-3 sm:px-8 rounded-lg shadow-lg duration-300 text-sm sm:text-base"
                      disabled={
                        !banner.brand_id &&
                        !banner.category_id &&
                        !banner.sub_category_id
                      }
                    >
                      {banner.button_text || "Shop Now"}
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="container text-center py-20">
            <p className="text-slate-400">No banners available right now.</p>
          </div>
        )}
      </section>

      <section className="relative md:py-10 py-8 px-4">
        {/* Categories Section */}
<div className="container mx-auto max-w-7xl bg-[#F5F2F2] py-6 px-4 rounded-lg">
  {loading ? (
    <Swiper
      modules={[Autoplay, Pagination]}
      spaceBetween={15}
      slidesPerView={2}
      autoplay={{ delay: 2000 }}
      pagination={{ clickable: true }}
      breakpoints={{
        640: { slidesPerView: 3 },
        768: { slidesPerView: 4 },
      }}
      className="pb-6"
    >
      {[...Array(5)].map((_, index) => (
        <SwiperSlide key={index}>
          <div className="text-center">
            <Skeleton
              height={100}
              width={100}
              circle={true}
              className="mx-auto"
            />
            <Skeleton height={20} width={80} className="mx-auto mt-2" />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  ) : error ? (
    <div className="text-center py-6">
      <p className="text-red-500">{error}</p>
    </div>
  ) : !categories || categories.length === 0 ? (
    <div className="text-center py-6">
      <p className="text-slate-400">
        No categories found at the moment.
      </p>
      <Link
        to="/shop-grid"
        className="mt-2 inline-block text-blue-500 hover:underline"
      >
        Browse all products
      </Link>
    </div>
  ) : (
    <Swiper
      modules={[Autoplay, Pagination]}
      spaceBetween={15}
      slidesPerView={2}
      autoplay={{ delay: 2000 }}
      pagination={{ clickable: true }}
      breakpoints={{
        640: { slidesPerView: 3 },
        768: { slidesPerView: 4 },
      }}
      className="pb-6"
    >
      {(() => {
        // Create a new array with repeated categories if there are less than 6
        const categoriesToDisplay = categories.length < 6 
          ? [...categories, ...categories].slice(0, 6) 
          : categories;
        
        return categoriesToDisplay.map((category, index) => (
          <SwiperSlide key={`${category.category_name_id}-${index}`}>
            <button
              onClick={() =>
                handleCategoryClick(category?.category_name_id)
              }
              className="text-center hover:text-green-500 w-full"
            >
              <div className="relative mx-auto w-38 h-38 sm:w-40 sm:h-40 md:w-52 md:h-52 lg:w-56 lg:h-56">
                <img
                  src={`${BASE_MEDIA_URL}${category?.category_image}`}
                  className="w-full h-full rounded-md shadow object-cover hover:shadow-lg transition-shadow duration-300"
                  alt=""
                />
              </div>
              <span className="text-sm sm:text-base font-medium mt-2 block">
                {category?.category_name}
              </span>
            </button>
          </SwiperSlide>
        ));
      })()}
    </Swiper>
  )}
</div>

        {/* Brands Section */}
        <div className="container mx-auto mt-8">
          <div className="text-center mb-6">
            <h2 className="text-xl sm:text-2xl font-bold mb-2">
              Shop By Brand
            </h2>
            <p className="text-slate-400">Browse our popular brands</p>
          </div>

          {loading ? (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={3}
              spaceBetween={15}
              pagination={{ clickable: true }}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              loop={true}
              breakpoints={{
                640: { slidesPerView: 4 },
                768: { slidesPerView: 5 },
              }}
              className="max-w-7xl w-full"
            >
              {Array.from({ length: 8 }).map((_, index) => (
                <SwiperSlide key={`skeleton-${index}`}>
                  <div className="flex flex-col items-center justify-center text-center">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 bg-slate-200 rounded-full shadow-md animate-pulse mx-auto"></div>
                    <div className="mt-3 h-5 w-20 bg-slate-200 animate-pulse rounded mx-auto"></div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : error ? (
            <div className="text-center py-6">
              <p className="text-red-500">Error loading brands: {error}</p>
            </div>
          ) : !brand || brand.length === 0 ? (
            <div className="text-center py-6">
              <p className="text-slate-400">No brands found at the moment.</p>
              <Link
                to="/shop-grid"
                className="mt-2 inline-block text-blue-500 hover:underline"
              >
                Browse all products
              </Link>
            </div>
          ) : (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={3}
              spaceBetween={15}
              pagination={{ clickable: true }}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              loop={true}
              breakpoints={{
                640: { slidesPerView: 4 },
                768: { slidesPerView: 5 },
              }}
              className="max-w-7xl w-full"
            >
              {(() => {
                // Create a new array with repeated brands if there are less than 6
                const brandsToDisplay =
                  brand.length < 6 ? [...brand, ...brand].slice(0, 6) : brand;

                return brandsToDisplay.map((item, index) => {
                  const brandId = item.brand_details.brand_id;
                  const brandName = item.brand_details.brand_name || "Unknown";
                  const logoSrc = item.brand_details.brand_logo
                    ? `${BASE_MEDIA_URL}${item.brand_details.brand_logo}`
                    : null;

                  return (
                    <SwiperSlide key={`${brandId}-${index}`}>
                      <div
                        onClick={() => handlepbrandClick(brandId)}
                        className="flex flex-col items-center justify-center text-center transition-all duration-300 transform hover:scale-105 hover:bg-slate-50 rounded-lg p-3 cursor-pointer group"
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handlepbrandClick(brandId);
                          }
                        }}
                      >
                        {logoSrc ? (
                          <img
                            src={logoSrc}
                            alt={brandName}
                            className="w-16 h-16 sm:w-20 sm:h-20 rounded-full shadow-md object-cover group-hover:shadow-lg transition-shadow duration-300"
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.nextSibling.style.display = "flex";
                            }}
                          />
                        ) : (
                          <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-emerald-600 text-white flex items-center justify-center text-xl font-bold">
                            {brandName.charAt(0).toUpperCase()}
                          </div>
                        )}

                        <div
                          className="hidden w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-emerald-600 text-white flex items-center justify-center text-xl font-bold"
                          style={{ display: logoSrc ? "none" : "flex" }}
                        >
                          {brandName.charAt(0).toUpperCase()}
                        </div>

                        <h6 className="mt-3 font-medium text-sm sm:text-base capitalize group-hover:text-emerald-600 transition-colors duration-300">
                          {brandName}
                        </h6>
                      </div>
                    </SwiperSlide>
                  );
                });
              })()}
            </Swiper>
          )}
        </div>

        {/* New Arrivals Section */}
<div className="container mx-auto mt-10">
  <div className="text-center mb-6">
    <h2 className="text-xl sm:text-2xl font-bold mb-2">New Arrivals</h2>
    <p className="text-slate-400">Check out our latest products</p>
  </div>

  {loading ? (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 py-4">
      {[...Array(6)].map((_, index) => (
        <div
          key={index}
          className="animate-pulse flex flex-col items-center rounded-md shadow p-2"
        >
          <div className="bg-gray-300 dark:bg-gray-700 w-full h-32 rounded-md mb-3"></div>
          <div className="bg-gray-300 dark:bg-gray-700 h-4 w-3/4 rounded mb-2"></div>
          <div className="bg-gray-300 dark:bg-gray-700 h-4 w-1/2 rounded mb-2"></div>
          <div className="bg-gray-300 dark:bg-gray-700 h-4 w-1/3 rounded"></div>
        </div>
      ))}
    </div>
  ) : error ? (
    <div className="text-center py-6">
      <p className="text-red-500">
        Error loading new arrivals: {error}
      </p>
    </div>
  ) : !Product ||
    !Array.isArray(Product.results) ||
    Product.results.length === 0 ? (
    <div className="text-center py-6">
      <p className="text-slate-400">
        No new arrivals found at the moment.
      </p>
      <Link
        to="/shop-grid"
        className="mt-2 inline-block text-blue-500 hover:underline"
      >
        Browse all products
      </Link>
    </div>
  ) : (
    <Swiper
      modules={[Autoplay, Pagination]}
      spaceBetween={15}
      slidesPerView={2}
      pagination={{ clickable: true }}
      autoplay={{ delay: 1500 }}
      breakpoints={{
        640: { slidesPerView: 3 },
        768: { slidesPerView: 4 },
        1024: { slidesPerView: 5 },
      }}
      className="pt-4"
    >
      {(() => {
        // Create a new array with repeated products if there are less than 6
        const productsToDisplay = Product.results.length < 6 
          ? [...Product.results, ...Product.results].slice(0, 8) 
          : Product.results;
        
        return productsToDisplay.map((product, index) => {
          const firstVariant = product.variants?.[0];
          const firstSize = firstVariant?.sizes?.[0];
          const discountedPrice =
            firstSize?.price?.discounted || firstSize?.price?.mrp || null;
          const originalPrice =
            firstSize?.price?.mrp ||
            (typeof firstSize?.price === "number"
              ? firstSize?.price
              : null);
          const currency = firstSize?.price?.currency || "INR";
          const currencySymbol = getCurrencySymbol(currency);

          const handleAddToWishlist = async (e) => {
            e.preventDefault();
            e.stopPropagation();

            try {
              const customer_id = localStorage.getItem("customer_id");
              if (!customer_id) {
                toast.error("Please login first!", {
                  position: "top-center",
                  style: {
                    borderRadius: "10px",
                    background: "#333",
                    color: "#fff",
                  },
                });
                return;
              }

              const sku_code =
                firstSize?.sku || firstVariant?.sku_code || null;

              if (!sku_code) {
                toast.error("Product information incomplete!", {
                  position: "top-center",
                  style: {
                    borderRadius: "10px",
                    background: "#333",
                    color: "#fff",
                  },
                });
                return;
              }

              const payload = {
                product_id: product?.product_id || product?.id,
                sku_code,
                customer_id,
              };

              const response = await addTowishlistApi(payload);

              if (response?.message) {
                toast.success("Added to wishlist ❤️", {
                  position: "top-center",
                  style: {
                    borderRadius: "10px",
                    background: "#333",
                    color: "#fff",
                  },
                });
              } else {
                toast.error(
                  response?.error || "Failed to add to wishlist!",
                  {
                    position: "top-center",
                    style: {
                      borderRadius: "10px",
                      background: "#333",
                      color: "#fff",
                    },
                  }
                );
              }
            } catch (error) {
              console.error("Wishlist API error:", error);
              toast.error("Something went wrong!", {
                position: "top-center",
                style: {
                  borderRadius: "10px",
                  background: "#333",
                  color: "#fff",
                },
              });
            }
          };

          return (
            <SwiperSlide key={`${product.product_id}-${index}`}>
              <div className="group">
                <div className="relative overflow-hidden shadow rounded-md group-hover:shadow-lg duration-500">
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={`${BASE_MEDIA_URL}${
                        product.main_image ||
                        product.variants?.[0]?.images?.[0] ||
                        ""
                      }`}
                      className="group-hover:scale-110 duration-500 w-full h-full object-cover"
                      alt={product?.name}
                      onError={(e) => {
                        e.target.src = "/path/to/fallback-image.jpg";
                      }}
                    />
                  </div>

                  <ul className="list-none absolute top-2 right-2 opacity-0 group-hover:opacity-100 duration-500 space-y-1">
                    <li>
                      <button
                        onClick={handleAddToWishlist}
                        className="size-8 inline-flex items-center justify-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"
                      >
                        <FiHeart className="size-4" />
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() =>
                          handleProductClick(product?.product_id)
                        }
                        className="size-8 inline-flex items-center justify-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"
                      >
                        <FiEye className="size-4" />
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleCustomizeClick(product)}
                        className="size-8 inline-flex items-center justify-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"
                      >
                        <FiEdit className="size-4" />
                      </button>
                    </li>
                  </ul>

                  <ul className="list-none absolute top-2 left-2">
                    {product.offer && (
                      <li>
                        <Link
                          to="#"
                          className="bg-orange-600 text-white text-xs font-bold px-2 py-1 rounded"
                        >
                          {product.tag || "Offer"}
                        </Link>
                      </li>
                    )}
                    {product.tag === "New" && (
                      <li>
                        <Link
                          to="#"
                          className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded"
                        >
                          {product.tag}
                        </Link>
                      </li>
                    )}
                    {product.tag === "Featured" && (
                      <li>
                        <Link
                          to="#"
                          className="bg-emerald-600 text-white text-xs font-bold px-2 py-1 rounded"
                        >
                          {product.tag}
                        </Link>
                      </li>
                    )}
                    {discountedPrice &&
                      originalPrice &&
                      discountedPrice < originalPrice && (
                        <li>
                          <Link
                            to="#"
                            className="bg-orange-600 text-white text-xs font-bold px-2 py-1 rounded"
                          >
                            Sale
                          </Link>
                        </li>
                      )}
                  </ul>
                </div>

                <div className="mt-3 px-1">
                  <button
                    onClick={() =>
                      handleProductClick(product?.product_id)
                    }
                    className="text-center hover:text-green-500 w-full"
                  >
                    <span className="text-sm font-medium block truncate">
                      {product.name}
                    </span>
                  </button>

                  <div className="flex justify-between items-center mt-1">
                    <p className="text-sm">
                      {discountedPrice !== null
                        ? `${currencySymbol}${discountedPrice}`
                        : "Price not available"}
                      {originalPrice !== null &&
                        originalPrice !== discountedPrice && (
                          <del className="text-slate-400 text-xs ml-1">
                            {currencySymbol}
                            {originalPrice}
                          </del>
                        )}
                    </p>
                    <ul className="flex text-xs text-amber-400 list-none">
                      {[...Array(5)].map((_, i) => (
                        <li key={i} className="inline-block">
                          <i
                            className={
                              i < Math.round(product.ratings?.avg || 5)
                                ? "mdi mdi-star"
                                : "mdi mdi-star-outline"
                            }
                          ></i>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {product.description && (
                    <p className="text-xs text-slate-500 mt-1 truncate">
                      {product.description.substring(0, 50)}...
                    </p>
                  )}
                </div>
              </div>
            </SwiperSlide>
          );
        });
      })()}
    </Swiper>
  )}
</div>

        {/* Sale Section - Full Width on Desktop */}
        <div className="w-full mt-10 md:mt-16">
          <div
            className="relative overflow-hidden py-12 md:py-20 px-4 md:px-10 bg-orange-600 bg-center bg-no-repeat bg-cover"
            style={{ backgroundImage: `url(${heroBg})` }}
          >
            <div
              className="absolute inset-0 bg-center bg-no-repeat bg-cover opacity-20"
              style={{ backgroundImage: `url(${ctaImg})` }}
            ></div>
            <div className="relative z-10 max-w-6xl mx-auto">
              <div className="grid grid-cols-1 justify-center text-center">
                <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-normal tracking-wide font-bold text-white mb-6">
                  End of Season Clearance <br /> Sale up to 30%
                </h3>
                <div id="countdown" className="mt-6">
                  <ul className="count-down list-none flex justify-center flex-wrap">
                    <li
                      id="days"
                      className="mx-1 pt-1 text-xl sm:text-2xl md:text-3xl leading-[60px] h-[60px] sm:h-[70px] md:h-[80px] w-[60px] sm:w-[70px] md:w-[80px] font-medium rounded-md shadow shadow-gray-100 inline-block text-center text-white bg-black/30"
                    >
                      {days}
                      <p className="count-head text-xs sm:text-sm mt-6">Days</p>
                    </li>
                    <li
                      id="hours"
                      className="mx-1 pt-1 text-xl sm:text-2xl md:text-3xl leading-[60px] h-[60px] sm:h-[70px] md:h-[80px] w-[60px] sm:w-[70px] md:w-[80px] font-medium rounded-md shadow shadow-gray-100 inline-block text-center text-white bg-black/30"
                    >
                      {hours}
                      <p className="count-head text-xs sm:text-sm mt-6">
                        Hours
                      </p>
                    </li>
                    <li
                      id="mins"
                      className="mx-1 pt-1 text-xl sm:text-2xl md:text-3xl leading-[60px] h-[60px] sm:h-[70px] md:h-[80px] w-[60px] sm:w-[70px] md:w-[80px] font-medium rounded-md shadow shadow-gray-100 inline-block text-center text-white bg-black/30"
                    >
                      {minutes}
                      <p className="count-head text-xs sm:text-sm mt-6">Mins</p>
                    </li>
                    <li
                      id="secs"
                      className="mx-1 pt-1 text-xl sm:text-2xl md:text-3xl leading-[60px] h-[60px] sm:h-[70px] md:h-[80px] w-[60px] sm:w-[70px] md:w-[80px] font-medium rounded-md shadow shadow-gray-100 inline-block text-center text-white bg-black/30"
                    >
                      {seconds}
                      <p className="count-head text-xs sm:text-sm mt-6">Secs</p>
                    </li>
                    <li id="end" className="h1"></li>
                  </ul>
                </div>
                <div className="mt-6">
                  <Link
                    to="/sale"
                    className="py-3 px-6 sm:py-4 sm:px-8 inline-block font-semibold tracking-wide align-middle text-center bg-white text-green-500 rounded-md text-base sm:text-lg shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    <i className="mdi mdi-cart-outline mr-2"></i> Shop Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Trending Products Section */}
        <div className="container mx-auto mt-10">
          <div className="flex flex-col sm:flex-row justify-between items-center mb-6">
            <div className="text-center sm:text-left mb-4 sm:mb-0">
              <h2 className="text-xl sm:text-2xl font-bold mb-1">
                Trending Products
              </h2>
              <p className="text-slate-400">Popular items this week</p>
            </div>
            <div className="sm:text-right">
              <Link
                to="/shop-grid"
                className="text-slate-400 hover:text-green-500 text-sm"
              >
                See More Items <i className="mdi mdi-arrow-right"></i>
              </Link>
            </div>
          </div>

          {trendingLoading ? (
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={15}
              slidesPerView={2}
              pagination={{ clickable: true }}
              breakpoints={{
                640: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
              }}
            >
              {[...Array(6)].map((_, index) => (
                <SwiperSlide key={index}>
                  <div className="animate-pulse flex flex-col items-center rounded-md shadow p-2">
                    <div className="bg-gray-300 w-full h-32 rounded-md mb-3"></div>
                    <div className="bg-gray-300 h-4 w-3/4 rounded mb-2"></div>
                    <div className="bg-gray-300 h-4 w-1/2 rounded mb-2"></div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : trendingError ? (
            <div className="text-center py-6">
              <p className="text-red-500">Error: {trendingError}</p>
            </div>
          ) : trendingProducts.length === 0 ? (
            <div className="text-center py-6">
              <p className="text-slate-400">
                No trending items found at the moment.
              </p>
            </div>
          ) : (
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={15}
              slidesPerView={2}
              autoplay={{ delay: 2000 }}
              pagination={{ clickable: true }}
              breakpoints={{
                640: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
              }}
            >
              {trendingProducts.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="group">
                    <div className="relative overflow-hidden shadow rounded-md group-hover:shadow-lg duration-500">
                      <div className="h-40 overflow-hidden">
                        <img
                          src={`${BASE_MEDIA_URL}${
                            item.main_image ||
                            item.variants?.[0]?.images?.[0] ||
                            ""
                          }`}
                          alt={item.name}
                          className="group-hover:scale-110 duration-500 w-full h-full object-cover"
                        />
                      </div>
                      <div className="absolute -bottom-16 group-hover:bottom-3 start-3 end-3 duration-500">
                        <button
                          onClick={() => {
                            addToCart(
                              item,
                              1,
                              item.variants?.[0]?.color || null,
                              item.variants?.[0]?.sizes?.[0]?.size || null
                            );
                            navigate("/shop-cart");
                          }}
                          className="py-2 px-4 bg-slate-900 text-white rounded-md w-full text-sm"
                        >
                          Add to Cart
                        </button>
                      </div>
                    </div>

                    <div className="mt-3 text-center">
                      <button
                        onClick={() => handleProductClick(item.product_id)}
                        className="hover:text-green-500 font-medium text-sm truncate block"
                      >
                        {item.name}
                      </button>
                      <p className="mt-1 text-sm">
                        ₹{item.variants?.[0]?.sizes?.[0]?.price?.mrp || "0"}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </section>

      <BottomNav />
      <Footer />
      <Switcher />
      <ScrollToTop />
    </>
  );
}
